import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../store';
import { changeTab, TMapTab } from '../../../store/map_tabs';
import { IOfferMapTabsProps, OfferMapTabs } from './tabs';

type TStoreProps = Pick<
  IOfferMapTabsProps,
  'activeTab' | 'offer' | 'specialProject' | 'specialPromoInfo' | 'subdomain'
>;

type TDispatchProps = Pick<IOfferMapTabsProps, 'changeTab'>;

function mapStateToProps(state: IState): TStoreProps {
  return {
    activeTab: state.mapTabs.activeTab,
    offer: state.offerData.offer,
    specialProject: state.offerData.specialProject,
    specialPromoInfo: state.specialPromoInfo,
    subdomain: state.pageData.subdomain,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): TDispatchProps {
  return {
    changeTab: (tab: TMapTab) => dispatch(changeTab(tab)),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferMapTabsContainer = connect<TStoreProps, TDispatchProps, {}>(
  mapStateToProps,
  mapDispatchToProps,
)(OfferMapTabs);
